/* eslint-disable no-unused-vars */
export const adCustomizersStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  adCustomizerPickerEditorContainer: {
    '&.picker-list': {
      maxHeight: 432,
      overflowY: 'auto',

      '& > li ~ li, & > .adcustomizerpicker-syntax-container ~ li': {
        borderTop: `1px solid ${palette.neutralSecondary}`,
      },

      '& > li > a': {
        fontSize: 14,
        height: 'auto',
      },
    },

    '& .adcustomizerpicker-syntax-container': {
      padding: '27px 32px 16px 32px',

      '& ~ li > a': {
        padding: '0 32px',
      },
    },

    '&.dropdown-menu.adCustomizersEditor': {
      fontSize: 14,
      lineHeight: '19px',

      '& label': {
        padding: '0 0 7px 0',
        '& .ms-ChoiceFieldLabel': {
          fontWeight: '400',
        },
      },

      '& .ms-Stack > span': {
        paddingTop: '6px',
      },

      '& .picker-content': {
        borderTop: `1px solid ${palette.neutralSecondary}`,
        padding: '16px 32px 32px 32px',

        '& .countdownEditor': {
          '& .ms-TextField': {
            width: '150px',
          },

          '& .ms-Stack': {
            marginBottom: '32px',
          },

          '& .ms-Stack:last-child': {
            marginBottom: '0px',
          },

          '& .language-dropdown': {
            width: 'fit-content',
            minWidth: '180px',
          },
        },
      },

      '& .location-editor': {
        '& input[type="radio"]': {
          marginLeft: '0px',
        },
        '& label.control-label': {
          marginTop: '10px',
        },
      },

      '& .keyword-editor': {
        '& .ms-TextField': {
          marginBottom: '36px',
        },
      },
    },
  },
});

